import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

interface ToastState {
  id: number;
  msg: string;
  type: 'error' | 'warning' | 'success';
  duration: number;
}

const initialState: ToastState[] = [];

export const ToastsSlice = createSlice({
  name: 'toasts',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    addErrorToast: (
      state,
      action: PayloadAction<{ msg: string; duration?: number }>
    ) => {
      // state.id = action.payload.id;
      state.push({
        id: Date.now(),
        msg: action.payload.msg,
        duration: action.payload.duration || 1000,
        type: 'error'
      });
    },
    addSuccessToast: (
      state,
      action: PayloadAction<{ msg: string; duration?: number }>
    ) => {
      // state.id = action.payload.id;
      state.push({
        id: Date.now(),
        msg: action.payload.msg,
        duration: action.payload.duration || 1000,
        type: 'success'
      });
    },
    removeToast: (state, action: PayloadAction<{ id: number }>) => {
      // state.id = action.payload.id;
      state.splice(
        state.map((toast) => toast.id).indexOf(action.payload.id),
        1
      );
    }
  }
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  // extraReducers: (builder) => {
  //   builder
  //     .addCase(incrementAsync.pending, (state) => {
  //       state.status = 'loading';
  //     })
  //     .addCase(incrementAsync.fulfilled, (state, action) => {
  //       state.status = 'idle';
  //       state.value += action.payload;
  //     })
  //     .addCase(incrementAsync.rejected, (state) => {
  //       state.status = 'failed';
  //     });
  // }
});

export const { addErrorToast, addSuccessToast, removeToast } =
  ToastsSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const getToasts = (state: RootState) => state.toasts;

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
// export const incrementIfOdd =
//   (amount: number): AppThunk =>
//   (dispatch, getState) => {
//     const currentValue = selectCount(getState());
//     if (currentValue % 2 === 1) {
//       dispatch(incrementByAmount(amount));
//     }
//   };

export default ToastsSlice.reducer;
